@if (activeAlert(); as alert) {
<div class="subscription-alert-banner banner-level-{{ alert.level.toLowerCase() }} d-block d-lg-none p-3 mb-3 rounded-4 shadow-sm animate__animated animate__fadeIn position-relative">
  <div class="d-flex flex-column gap-2.5">
    
    <!-- Left Icon & Messaging -->
    <div class="d-flex align-items-start gap-2.5">
      <div class="banner-icon-container flex-shrink-0 d-flex align-items-center justify-content-center rounded-3 mt-0.5">
        @if (alert.type === 'DIGITAL_SIGNATURE') {
          <i class="fas fa-shield-alt text-warning fs-5"></i>
        } @else if (alert.type === 'SIAT_TOKEN') {
          <i class="fas fa-key text-warning fs-5"></i>
        } @else {
          @if (alert.level === 'CRITICAL') {
            <i class="fas fa-lock text-danger fs-5"></i>
          } @else if (alert.level === 'URGENT') {
            <i class="fas fa-exclamation-triangle text-warning fs-5"></i>
          } @else if (alert.level === 'WARNING') {
            <i class="fas fa-clock text-warning fs-5"></i>
          } @else {
            <i class="fas fa-info-circle text-info fs-5"></i>
          }
        }
      </div>
      <div class="flex-grow-1 pe-3">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
          @if (alert.type === 'DIGITAL_SIGNATURE') {
            @if (alert.level === 'CRITICAL') {
              <span class="badge bg-danger text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-shield-alt me-1"></i> FIRMA DIGITAL VENCIDA
              </span>
            } @else if (alert.level === 'URGENT') {
              <span class="badge bg-danger text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-fire me-1"></i> ¡FIRMA DIGITAL VENCE EN {{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'DÍA' : 'DÍAS' }}!
              </span>
            } @else if (alert.level === 'WARNING') {
              <span class="badge bg-warning text-dark px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-shield-alt me-1"></i> FIRMA DIGITAL ({{ alert.daysRemaining }} DÍAS)
              </span>
            }
          } @else if (alert.type === 'SIAT_TOKEN') {
            @if (alert.level === 'CRITICAL') {
              <span class="badge bg-danger text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-key me-1"></i> TOKEN SIAT VENCIDO
              </span>
            } @else if (alert.level === 'URGENT') {
              <span class="badge bg-danger text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-fire me-1"></i> ¡TOKEN SIAT VENCE EN {{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'DÍA' : 'DÍAS' }}!
              </span>
            } @else if (alert.level === 'WARNING') {
              <span class="badge bg-warning text-dark px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-key me-1"></i> TOKEN SIAT ({{ alert.daysRemaining }} DÍAS)
              </span>
            }
          } @else {
            @if (alert.level === 'CRITICAL') {
              <span class="badge bg-danger text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-exclamation-circle me-1"></i>
                {{ isSuspended() ? 'CUENTA SUSPENDIDA' : 'CUENTA VENCIDA' }}
              </span>
            } @else if (alert.level === 'URGENT') {
              <span class="badge bg-danger text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-fire me-1"></i>
                ¡VENCE EN {{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'DÍA' : 'DÍAS' }}!
              </span>
            } @else if (alert.level === 'WARNING') {
              <span class="badge bg-warning text-dark px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-clock me-1"></i>
                RENOVACIÓN PRÓXIMA ({{ alert.daysRemaining }} DÍAS)
              </span>
            } @else if (alert.level === 'INFO') {
              <span class="badge bg-info text-white px-2 py-0.5 rounded-pill font-size-11 fw-bold">
                <i class="fas fa-info-circle me-1"></i>
                RECORDATORIO ({{ alert.daysRemaining }} DÍAS)
              </span>
            }
          }
        </div>
        <p class="banner-message mb-0 font-size-13">
          @if (alert.type === 'DIGITAL_SIGNATURE') {
            @if (alert.level === 'CRITICAL') {
              Tu Certificado de Firma Digital ha expirado. No es posible firmar ni emitir facturas electrónicas. Contacta a soporte para renovarlo ante ADSIB.
            } @else if (alert.level === 'URGENT') {
              ¡Atención! Tu Firma Digital vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan solo <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong>). Tramita tu renovación para evitar la suspensión de facturación.
            } @else if (alert.level === 'WARNING') {
              Tu Firma Digital vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (quedan {{ alert.daysRemaining }} días). Recuerda coordinar la renovación de tu certificado digital.
            }
          } @else if (alert.type === 'SIAT_TOKEN') {
            @if (alert.level === 'CRITICAL') {
              Tu Token Delegado SIAT ha expirado. La firma y emisión de facturas electrónicas está inhabilitada. Actualiza tu token ante el SIN.
            } @else if (alert.level === 'URGENT') {
              ¡Atención! Tu Token Delegado SIAT vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan solo <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong>). Actualiza tu token para evitar cortes en caja.
            } @else if (alert.level === 'WARNING') {
              Tu Token Delegado SIAT vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (quedan {{ alert.daysRemaining }} días). Recuerda renovar tu token a tiempo.
            }
          } @else {
            @if (alert.level === 'CRITICAL') {
              @if (isSuspended()) {
                Tu cuenta ha sido suspendida administrativamente. Comunícate con ventas para reactivar tu servicio.
              } @else {
                Tu suscripción al plan <strong class="text-body-emphasis">{{ planName() }}</strong> está vencida@if(alert.expirationDate){ desde el <strong class="text-danger">{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong>}. Regulariza tu suscripción para emitir facturas.
              }
            } @else if (alert.level === 'URGENT') {
              ¡Atención! Quedan solo <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong> de vigencia en tu plan <strong class="text-body-emphasis">{{ planName() }}</strong> (vence el <strong class="text-danger">{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong>). Renueva tu suscripción para evitar cortes ante el SIAT.
            } @else if (alert.level === 'WARNING') {
              Tu suscripción al plan <strong class="text-body-emphasis">{{ planName() }}</strong> vence en <strong>{{ alert.daysRemaining }} días</strong> (el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong>). Recuerda renovar a tiempo.
            } @else if (alert.level === 'INFO') {
              Tu plan <strong class="text-body-emphasis">{{ planName() }}</strong> está vigente hasta el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan {{ alert.daysRemaining }} días). Renueva con anticipación.
            }
          }
        </p>
      </div>
    </div>

    <!-- Bottom Action Button on Mobile -->
    <div class="banner-actions w-100 pt-1 d-flex flex-column gap-2">
      @if (alert.type === 'DIGITAL_SIGNATURE') {
        <a [href]="alert.whatsappUrl" target="_blank" class="btn btn-success btn-sm rounded-pill py-2 w-100 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm banner-action-btn">
          <i class="bx bxl-whatsapp fs-5"></i>
          <span class="fw-semibold font-size-13">Renovar Firma Digital</span>
        </a>
      } @else if (alert.type === 'SIAT_TOKEN') {
        <button type="button" class="btn btn-primary btn-sm rounded-pill py-2 w-100 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm banner-action-btn" (click)="openRefreshTokenModal()">
          <i class="fas fa-sync-alt fs-5"></i>
          <span class="fw-semibold font-size-13">Actualizar Token SIAT</span>
        </button>
        <a [href]="alert.whatsappUrl" target="_blank" class="btn btn-success btn-sm rounded-pill py-2 w-100 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm banner-action-btn">
          <i class="bx bxl-whatsapp fs-5"></i>
          <span class="fw-semibold font-size-13">Asistencia por WhatsApp</span>
        </a>
      } @else {
        <a [href]="alert.whatsappUrl" target="_blank" class="btn btn-success btn-sm rounded-pill py-2 w-100 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm banner-action-btn">
          <i class="bx bxl-whatsapp fs-5"></i>
          <span class="fw-semibold font-size-13">{{ alert.level === 'CRITICAL' ? 'Contactar a Ventas' : 'Renovar por WhatsApp' }}</span>
        </a>
      }
    </div>

  </div>

  <!-- Close / Dismiss button (Solo visible en niveles informativos / warning) -->
  @if (alert.isDismissible) {
    <button type="button" class="btn-close banner-close-btn position-absolute top-0 end-0 m-2.5" aria-label="Cerrar" (click)="dismiss()" title="Cerrar aviso"></button>
  }
</div>
}
